<div class="pie-chart-wrapper" *ngIf="chartOptions && chartOptions.series">
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [labels]="chartOptions.labels"
    [legend]="chartOptions.legend"
    [dataLabels]="chartOptions.dataLabels"
    [colors]="chartOptions.colors"
    [states]="chartOptions.states"
    [stroke]="chartOptions.stroke"
  ></apx-chart>
</div>
